import { styled, typography } from '@pulse-web-ui/theme';

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const QuestionGroup = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;

  [data-testid='insurance-agent-own-reason'] > div:last-child > p:last-child {
    display: none;
  }
`;

export const QuestionTitle = styled.legend`
  ${typography.medium20};
  width: 100%;
  margin: 0 0 16px;
  padding: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ErrorText = styled.div`
  ${typography.regular14};
  color: ${({ theme }) => theme.colors.text.error};
`;
